import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";
import Title from "@streeteasy/design-system/deprecated/Title";
import XButton from "@streeteasy/design-system/deprecated/XButton";

import SEModal from "../../../../shared/components/SEModal/SEModal";
import { largeScreen } from "../../../../shared/constants/screenSizes";

const CheckMark = styled.i.attrs(() => ({
  className: "fa fa-check"
}))`
  color: ${colors.primary};
  font-size: 14px;
  margin-right: 10px;

  @media screen and (max-width: ${largeScreen}px) {
    font-size: 12px;
    margin-right: 7px;
  }
`;

const Content = styled.div`
  display: flex;
  justify-content: center;
  padding: 65px 70px;

  @media screen and (max-width: ${largeScreen}px) {
    font-size: 12px;
    line-height: 21px;
    padding: 75px 30px 65px;
  }
`;

const UIModal = styled(SEModal)`
  margin-top: 150px;
  max-width: 580px;
  width: 580px;

  @media screen and (max-width: ${largeScreen}px) {
    margin-top: 5px;
    width: calc(100vw - 54px);
  }
`;

const StyledTitle = styled(Title)`
  margin-bottom: 20px;

  @media screen and (max-width: ${largeScreen}px) {
    margin-bottom: 38px;
    text-align: center;
  }
`;

const StyledXButton = styled(XButton)`
  position: absolute;
  right: 25px;
  top: 25px;
`;

CheckMark.displayName = "CheckMark";
Content.displayName = "Content";
StyledTitle.displayName = "Title";
StyledXButton.displayName = "XButton";
UIModal.displayName = "SEModal";

export { CheckMark, Content, StyledTitle, StyledXButton, UIModal };
